export class PublicCookie {
    isAuthenticated: boolean;
    tokenExpiration: Date;
}
